import { Hashing } from "../utils/Hashing.js";
class PlaceholderGenerator {
  static getFieldPlaceholder(fieldName) {
    return fieldName;
  }
  static getHasOneRelationPlaceholder(relation) {
    return `${relation.field}_${Hashing.hashHasOneRelation(relation)}`;
  }
  static getHasManyRelationPlaceholder(relation) {
    return `${relation.field}_${Hashing.hashHasManyRelation(relation)}`;
  }
  static getEntitySubTreePlaceholder(subTreeParameters, environment) {
    return `est_${Hashing.hashEntitySubTreeParameters(subTreeParameters, environment)}`;
  }
  static getEntityListSubTreePlaceholder(subTreeParameters, environment) {
    return `lst_${Hashing.hashEntityListSubTreeParameters(subTreeParameters, environment)}`;
  }
}
export {
  PlaceholderGenerator
};
//# sourceMappingURL=PlaceholderGenerator.js.map
